webpackJsonp([8],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENV */
/* unused harmony export server */
/* unused harmony export host */
/* unused harmony export passportHost */
var serverConfigs = __webpack_require__(8);
var ENV = "prod_na";
var server = serverConfigs[ENV];

var host = server.host;
var passportHost = server.passportHost;

/* harmony default export */ __webpack_exports__["a"] = ({
  host: server.host,
  passportHost: server.passportHost,
  env: ENV,
  APP_KEY: 'CZUR_PASSPORT_WEB',
  CHANNEL: 'ALL',
  DEFAULT_PAGE: 'basic.html',
  HTTP_HEADER_KEY: {
    APP_KEY: 'App-Key',
    UDID: 'udid',
    CHANNEL: 'Channel',
    TOKEN: 'T-ID',
    USERID: 'U-ID'
  },
  COOKIE_KEY: {
    U_ID: 'U-ID',
    TOKEN: 'T-ID',
    USER_NAME: 'user',
    LANG: 'lang'
  },
  CALL_BACK: '',
  R_CODE: {
    SUCCESS: 1000,
    INTERNAL_ERROR: 1001,
    INVALID_TOKEN: 1002,
    BAD_ACCESS: 1003,
    PWD_ERROR: 1004,
    USER_INACTIVE: 1005,
    CHANNEL_UNSUPPORT: 1006,
    INVALID_MOBILE: 1007,
    INVALID_EMAIL: 1008,
    SMS_MANY_REQUEST: 1009,
    SMS_SEND_10S: 1010,
    USER_EXIST: 1011,
    MAIL_MANY_REQUEST: 1012,
    MAIL_SEND_10S: 1013,
    INVALID_CODE: 1014,
    IMG_PRO_ERROR: 1015,
    IMG_PRO_ING: 1016,
    INVALID_USER_NAME: 1017,
    USER_NO_EXIST: 1018,
    TIME_OUT: 1019,
    IMG_NOT_FOUND: 1020,
    DEVICE_OCCUPIED: 1021,
    USER_USING_DEVICE: 1022,
    MANY_REQUEST_CODE: 1023,
    PWD_OLD_SAME: 1030,
    PWD_OLD_ERROR: 1031,
    NO_MOBILE_BIND: 1032,
    CODE_ERROR: 1033,
    MOBILE_USED_OTHERS: 1034,
    EMAIL_USED_OTHERS: 1035
  },
  getChannel: function getChannel() {
    var channel = this.getReqParam('Channel');
    if (!channel) {
      channel = this.CHANNEL;
    }
    return channel;
  },
  cookieSet: function cookieSet(key, value) {
    var Days = 30;
    var date = new Date();
    date.setTime(date.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + escape(value) + '; path=/;expires = ' + date.toGMTString();
  },
  cookieGet: function cookieGet(key) {
    var result;
    var mycookie = document.cookie;
    var start2 = mycookie.indexOf(key + '=');
    if (start2 > -1) {
      var start = mycookie.indexOf('=', start2) + 1;
      var end = mycookie.indexOf(';', start);
      if (end === -1) {
        end = mycookie.length;
      }
      result = unescape(mycookie.substring(start, end));
    }
    return result;
  },
  getReqParam: function getReqParam(param) {
    var url = window.location.search;
    var theRequest = {};
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1);
      var strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
      }
    }
    return theRequest[param];
  },
  appendParam: function appendParam(url, param, value) {
    var archor = '';
    if (url.indexOf('#') > 0) {
      var strs = url.split('#');
      url = strs[0];
      archor = strs[1];
    }
    if (url.indexOf('?') >= 0) {
      url = url + '&';
    } else {
      url = url + '?';
    }
    url = url + param + '=' + encodeURIComponent(value);
    if (archor !== '') {
      url = url + '#' + archor;
    }
    return url;
  },
  getLocalStore: function getLocalStore(key) {
    return localStorage.getItem(key);
  },
  setLocalStore: function setLocalStore(key, value) {
    localStorage.setItem(key, value);
  },
  lang: function lang() {
    var requestLang = this.getReqParam('lang');
    var currentLang = this.cookieGet('lang');
    if (requestLang !== undefined && requestLang !== '' && requestLang !== currentLang) {
      currentLang = requestLang;
      this.cookieSet('lang', currentLang);
    }
    if (!currentLang) {
      currentLang = navigator.language;
      if (!currentLang) {
        currentLang = navigator.browserLanguage;
      }
    }
    if (currentLang !== 'en' && currentLang !== 'zh-CN' && currentLang !== 'zh-TW' && currentLang !== 'ru_RU') {
      currentLang = 'en';
    }
    return currentLang;
  },
  local4Service: function local4Service() {
    var lang = this.lang();
    var local = lang.replace('-', '_');
    return local;
  },
  urlRemoveParam: function urlRemoveParam(param) {
    var url = window.location.href;
    if (window.location.search.indexOf(param[0]) >= 0) {
      var hosturl = url.replace(window.location.search, '').replace(window.location.hash, '');
      var params = window.location.search.substr(1);
      var strs = params.split('&');
      for (var m = 0; m < param.length; m++) {
        var one = param[m];
        for (var i = 0; i < strs.length; i++) {
          if (strs[i].indexOf(one) >= 0) {
            strs.splice(i, 1);
            break;
          }
        }
      }
      if (strs.length > 0) {
        var search = strs.join('&');
        hosturl = hosturl + '?' + search;
      }
      url = hosturl + window.location.hash;
    }
    return url;
  }
});

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacyEn"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('h1', [_vm._v("User Agreement")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("I. General Rules")]), _vm._v(" "), _c('div', [_vm._v("1.1 You (\"user\") agree to the terms of this User Agreement (the \"Agreement\") and follow the prompts on the page to complete all registration procedures. When you click the Agree button during the registration, it is deemed that you have reached an agreement with CZUR Cloud (\"we\", \"us\") and fully accepted all the terms under this Agreement.")]), _vm._v(" "), _c('div', [_vm._v("1.2 When you have successfully signed up, CZUR Cloud will grant you a user account and the corresponding password, which shall be kept secret and confidential by you; you shall be legally responsible for all activities and events you perform with the user account.")]), _vm._v(" "), _c('div', [_vm._v("1.3 Once you have signed up for a CZUR Cloud account. Unless a sub-channel requires separate permission, you have the right to use the Service of each channel of CZUR Cloud via the account. Your use of every single service of CZUR Cloud is deemed that you agree to the terms of service concerned and the announcements regarding the service issued by CZUR Cloud.")]), _vm._v(" "), _c('div', [_vm._v("1.4 CZUR Cloud has the right to update the CZUR Cloud membership service agreement and the terms of every single service and announcement for each channel at any time without prior notice. When using related services, you shall pay attention to and abide by the relevant terms applicable to the services. You shall read this Agreement carefully before using the services provided by CZUR Cloud. If you do not agree to this Agreement and/or the modification to it from time to time, you can cancel the services provided by CZUR Cloud. Once you use the services provided by CZUR Cloud, it is deemed that you have understood and fully agreed to the terms of this Agreement, including any amendments made by CZUR Cloud to this Agreement at any time, and that you have become a user of CZUR Cloud.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("II. Registration Information and Privacy Protection")]), _vm._v(" "), _c('div', [_vm._v("2.1 CZUR Cloud is the owner of CZUR Cloud accounts (i.e., CZUR Cloud user IDs). When you complete the registration procedures, you obtain the right to use a CZUR Cloud account. You shall provide detailed and accurate personal information promptly, and constantly update your registration information to meet the requirements of providing detailed and accurate information promptly. All original information you enter will be cited as registration information. CZUR Cloud shall bear no responsibility for the consequences of any problems caused by untrue registration information. CZUR Cloud shall bear no responsibility for any problems caused by untrue registration information or failure to update the registration information in time.")]), _vm._v(" "), _c('div', [_vm._v("2.2 You shall register for an account with real identity information, and registration information such as the account name and avatar submitted by you shall not contain any illegal or false information, otherwise, CZUR Cloud has the right to reject the registration. After registration, if it is found that you have obtained an account name with false information, or that the registration information such as account avatar contains illegal and false information, CZUR Cloud has the right to take methods such as unilaterally demanding correction within a time limit, suspending the account use, canceling the registration, and withdrawing the account.")]), _vm._v(" "), _c('div', [_vm._v("2.3 You shall not transfer, sell or lend your account number and password to others. If you authorize others to use your account, you shall be fully responsible for all actions that the authorized person performs with your account.")]), _vm._v(" "), _c('div', [_vm._v("2.4 The privacy protection statement of CZUR Cloud explains how CZUR Cloud collects and uses user information. You represent that you have fully understood and agreed that CZUR Cloud can process user information accordingly.")]), _vm._v(" "), _c('div', [_vm._v("2.5 CZUR Cloud may work with its partners to provide you with the services you request or to show you content that may be of interest to you. In the case where the information is necessary for the products/services you request, you agree that CZUR Cloud can share the necessary information with its partners. And, CZUR Cloud will require its partners to ensure data security and use the information for no other purposes. CZUR Cloud will not provide or share the information with any unrelated third parties.")]), _vm._v(" "), _c('div', [_vm._v("2.6 You agree that CZUR Cloud may disclose your information under the following conditions:")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("CZUR Cloud has obtained your authorization in advance;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("You've used the sharing feature;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("It is required by laws, regulations, legal processes, or mandatory requirements of government authorities;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("It is for academic research or the public interest;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("It is to safeguard the legitimate rights and interests of CZUR Cloud, such as querying and preventing and dealing with frauds or security issues;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("It is in line with the relevant terms of service or terms of use.")]), _vm._v(" "), _c('div', [_vm._v("2.7 You acknowledge and authorize CZUR Cloud to use or synchronize your information to its affiliates only when it is necessary to do so, to provide you with credit-related services.")]), _vm._v(" "), _c('div', [_vm._v("2.8 To allow CZUR Cloud to offer you better services, you agree that CZUR Cloud sends you relevant commercial service information via SMS message and other ways.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("III. Use Rules")]), _vm._v(" "), _c('div', [_vm._v("3.1 When using CZUR Cloud Service (the \"Service\"), you must abide by the relevant laws and regulations of the People's Republic of China. You agree that you will not use the service for any illegal or improper activities, including but not limited to the following acts:")]), _vm._v(" "), _c('div', [_vm._v("(1) You will not upload, display, post, disseminate or transmit in any way the information containing any of the following contents:")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("Information that")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("a) violates the fundamental principles established by the constitution;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("b) endangers national security, divulges state secrets, subverts state power, and damages national unity;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("c) damages national honor and interests;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("d) incites ethnic hatred and ethnic discrimination, or damages ethnic unity;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("e) damages the state's religious policy and promotes cults and feudal superstitions;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("f) spreads rumors, disrupts social order and social stability;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("g) spreads obscenity, pornography, gambling, violence, murder, and terror or instigates crimes;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("h) insults or slanders others, infringes on the legal rights of others;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("i) contains false, harmful, coercive content, invasion of privacy, harassment, infringing, libelous, vulgar, obscene, or other morally objectionable content;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("j) contains other content restricted or prohibited by Chinese laws, regulations, rules, ordinances, and any norms with legal effect;")]), _vm._v(" "), _c('div', [_vm._v("(2) You will not use the network service system for any illegal purpose;")]), _vm._v(" "), _c('div', [_vm._v("(3) You will not use the Service to engage in any of the following activities:")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("a) entering computers and information networks or using computers and information networks without permission;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("b) deleting, altering, or adding functions of computers and information networks without permission;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("c) deleting, altering, or adding data and applications stored, processed, or transmitted in computers and information networks without permission;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("d) deliberately producing or spreading destructive programs such as computer viruses;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("e) other acts that endanger the security of computers and information networks.")]), _vm._v(" "), _c('div', [_vm._v("3.2 You agree that you shall indemnify CZUR Cloud and its partner companies and affiliates against any compensation, demand, or loss (including reasonable attorney fees) claimed by any third party caused or incurred by your violation of the terms of this Agreement or related terms of service. In this regard, CZUR Cloud has the right to, depending on the attribute of your behaviors, take measures including but not limited to deleting the information that you publish, suspending the use permission, terminating the service, restricting the use, reclaiming your CZUR Cloud account, and pursuing legal liabilities. If you maliciously register an account or use an account to conduct illegal activities, disrupt, harass, or deceive other users, or commit other acts in violation of this Agreement, CZUR Cloud has the right to reclaim your account. At the same time, CZUR Cloud will assist in relevant investigations at the request of judicial departments.")]), _vm._v(" "), _c('div', [_vm._v("3.3 You shall not reproduce, copy, sell, resell or use any part of the Service or the use or acquisition of the Service for any other commercial purpose.")]), _vm._v(" "), _c('div', [_vm._v("3.4 You shall bear legal responsibility for your behaviors in the process of using the Service. You shall take your legal responsibility in ways including but not limited to: compensating the infringed and paying CZUR Cloud an equal amount of compensation after CZUR Cloud has first assumed the responsibility for administrative penalties or infringement damages caused by your behaviors.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("IV. Service Content")]), _vm._v(" "), _c('div', [_vm._v("4.1 The specific content of the CZUR Cloud network service is provided by CZUR Cloud according to the actual situation.")]), _vm._v(" "), _c('div', [_vm._v("4.2 Unless otherwise expressly stipulated in this Agreement, the new products, functions, and services launched by CZUR Cloud are all subject to this Agreement.")]), _vm._v(" "), _c('div', [_vm._v("4.3 To use this Service, you must be able to access the Internet through a third party legally qualified to provide you with an Internet access service, and you must pay the relevant service fees yourself. In addition, you must prepare and be responsible for all necessary equipment to connect to the Internet, including computers, modems, or other access devices.")]), _vm._v(" "), _c('div', [_vm._v("4.4 Given the particularity of the network service, you agree that CZUR Cloud has the right to change, interrupt or terminate some or all of the network services (including paid network services) at any time without prior notice. CZUR Cloud does not guarantee that the network service will not be interrupted, nor does it guarantee the timeliness, security, and accuracy of the network service.")]), _vm._v(" "), _c('div', [_vm._v("4.5 CZUR Cloud needs to repair or maintain the platform for providing network services or related equipment on a regular or irregular basis. CZUR Cloud shall assume no responsibility for the interruption of network services (including paid network services) within a reasonable period caused by such repair or maintenance. CZUR Cloud reserves the right to suspend, without prior notice, any part of this Service for maintenance, upgrade, or other purposes.")]), _vm._v(" "), _c('div', [_vm._v("4.6 Links to other websites or resources on the Internet may be provided in this Service or by any third party. Since CZUR Cloud has no control over these websites and resources, you acknowledge and agree that CZUR Cloud is not responsible for the availability of such websites or resources and that CZUR Cloud does not warrant and is not responsible for any content, advertisements, products or other materials on or derived from such sites or resources. CZUR Cloud shall not be liable for any damages or losses arising from the use of or reliance on any content, goods, or services published on or obtained through any such website or resource.")]), _vm._v(" "), _c('div', [_vm._v("4.7 You expressly agree to use CZUR Cloud Network Service at your sole risk. You understand and accept that any information downloaded or obtained through the Service is up to you and that you will bear the risk of system damage, data loss, etc. CZUR Cloud does not guarantee any commodity shopping service, transaction process, and recruitment information obtained on the service network.")]), _vm._v(" "), _c('div', [_vm._v("4.8 CZUR Cloud reserves the right to close accounts that have not been logged in for 6 months.")]), _vm._v(" "), _c('div', [_vm._v("4.9 CZUR Cloud reserves the right to modify or terminate this Service (or any part thereof) temporarily or permanently at any time, with or without prior notices, and CZUR Cloud shall not be liable to any user or any third party in this regard.")]), _vm._v(" "), _c('div', [_vm._v("4.10 Termination of Service")]), _vm._v(" "), _c('div', [_vm._v("You agree that CZUR Cloud may, at its discretion, terminate the use of your password and account or the use of the Service (or any part of the Service) and remove and delete any content you have in the Service for any reason, including but not limited to long-term (over one year) non-use or when CZUR Cloud believes that you have violated the text and principle of this Agreement. You agree that the service provided under any terms of this Agreement may be interrupted or terminated without prior notice, and you acknowledge and agree that CZUR Cloud may immediately close or delete your account and all related information and files in your account, and/or prohibit the continued use of the aforementioned documents or the Service. In addition, you agree that CZUR Cloud shall not be liable to you or any third party when the use of this Service is interrupted or terminated, or your account and related information and files are closed or deleted.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("V. Intellectual Property Rights and Other Legitimate Rights and Interests (including but not limited to Reputation and Goodwill)")]), _vm._v(" "), _c('div', [_vm._v("5.1 Users' Exclusive Rights")]), _vm._v(" "), _c('div', [_vm._v("CZUR Cloud respects the intellectual property rights and legitimate rights and interests of other people and calls on users to respect the intellectual property rights and legitimate rights and interests of other people. If you find that your intellectual property rights or other legitimate rights and interests have been infringed, follow the instructions below to file a notice of infringement with CZUR Cloud: Please note that, if you make any misrepresentation in the Infringement Notice, you will bear all legal responsibilities (including but not limited to compensation for various expenses and attorneys' fees) arising therefrom. If you are not sure whether material available online infringes any of your legitimate rights, we suggest that you first contact a relevant professional. To expedite our ability to process your request, please use the following format (including section numbers):")]), _vm._v(" "), _c('div', [_vm._v("1. Provide materials evidencing that you have the right of a trademark, copyright, or other legitimate rights you are authorized to exercise of the allegedly infringing content;")]), _vm._v(" "), _c('div', [_vm._v("2. Identify in sufficient detail the content of which the protected legitimate right that you believe has been infringed and the websites that contain the infringing content.")]), _vm._v(" "), _c('div', [_vm._v("3. Identify the material that you claim is infringing the legitimate right listed in Item 2 above.")]), _vm._v(" "), _c('div', [_vm._v("4. Provide detailed contact information of the Rights Holder, including name, a copy of the identity card or the passport (if an individual), a copy of the entity registration certificate (if an entity), address, telephone number, fax, and email address.")]), _vm._v(" "), _c('div', [_vm._v("5. Provide the location of infringing content on the Internet (for example, the source of allegedly infringing content, i.e., the website or location in the webpage) to permit us to notify the owner/administrator of the web page that allegedly contains infringing content).")]), _vm._v(" "), _c('div', [_vm._v("6. Include the following statement in the Infringement Notice: \"I represent that the information in this Infringement Notice is sufficient, true, and accurate and I confirm that if the statements in the Infringement Notice are not true, I will be legally liable for such misrepresentation.\"")]), _vm._v(" "), _c('div', [_vm._v("7. Sign the paper. If you are an entity or an organization established under laws, please chop your official stamp on the paper.")]), _vm._v(" "), _c('div', [_vm._v("Send the above-mentioned materials and contact information in writing to the following address:")]), _vm._v(" "), _c('div', [_vm._v("RM 1001, 10/F, Building A, No. 32 Huoju RD, High-Tech District, Dalian, China")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("CZUR TECH CO., LTD")]), _vm._v(" "), _c('div', [_vm._v("5.2 CZUR Cloud is the copyright owner of all the materials on this website. Any authorized acts of viewing, copying, printing, and disseminating materials on this website must meet the following conditions:")]), _vm._v(" "), _c('div', [_vm._v("All materials and images are obtained for informational purposes;")]), _vm._v(" "), _c('div', [_vm._v("All materials and images are not be used for commercial purposes;")]), _vm._v(" "), _c('div', [_vm._v("All materials, images, and any part thereof must include this copyright notice;")]), _vm._v(" "), _c('div', [_vm._v("All products, technologies, and all programs on this website (www.czur.cc) are the intellectual property of CZUR Cloud and are not authorized here. \"CZUR\", \"Czurtek\", \"CzurTek\" and the related graphics are registered trademarks of CZUR Cloud.")]), _vm._v(" "), _c('div', [_vm._v("No one shall use the trademarks without permission of CZUR Cloud (including but not limited to: copying, disseminating, displaying, mirroring, uploading, or downloading in an illegal manner). Otherwise, CZUR Cloud will pursue the legal responsibility of the party concerned according to law.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("VI. Special Notes for Minors")]), _vm._v(" "), _c('div', [_vm._v("Minors must abide by the National Youth Network Civilization Convention: Young people should absorb useful and not harmful information from the Internet, communicate in an honest and not insulting manner, strengthen self-protection consciousness, maintain Internet security, and not indulge in time-wasting activities.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("VII. Others")]), _vm._v(" "), _c('div', [_vm._v("7.1 The formulation, execution, and interpretation of this Agreement and the resolution of disputes for this Agreement shall be governed by the laws of the People's Republic of China.")]), _vm._v(" "), _c('div', [_vm._v("7.2 If there are any disputes over the contents of this Agreement or its implementation between you and CZUR Cloud, the disputes shall be solved by friendly negotiations. If the negotiation fails, either party may file a lawsuit in the local people's court with jurisdiction where CZUR Cloud is located.")]), _vm._v(" "), _c('div', [_vm._v("7.3 CZUR Cloud's failure to exercise any rights or terms under this Agreement does not constitute a waiver of the aforementioned rights.")]), _vm._v(" "), _c('div', [_vm._v("7.4 If any terms under this Agreement are completely or partially invalid or unenforceable for any reason, the remaining terms under this Agreement shall remain valid and binding. Please notify CZUR Cloud when you notice any violation of this Agreement, the terms of service of any single service, and announcements of CZUR Cloud. You can contact CZUR Cloud in the following way:")]), _vm._v(" "), _c('div', [_vm._v("RM 1001, 10/F, Building A, No. 32 Huoju RD, High-Tech District, Dalian, China  ")]), _vm._v(" "), _c('div', [_vm._v("CZUR TECH CO., LTD")]), _vm._v(" "), _c('div', [_vm._v("Postal Code: 116023")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-695f05c3", module.exports)
  }
}

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(93);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("39392ca3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37ecc2e3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_en.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37ecc2e3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_en.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(95);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4cbf7f68", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-695f05c3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./terms_en.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-695f05c3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./terms_en.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(482)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/privacy_terms_en/privacy_terms_en.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] privacy_terms_en.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fe178eba", Component.options)
  } else {
    hotAPI.reload("data-v-fe178eba", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacy_terms_en_vue__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacy_terms_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__privacy_terms_en_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__ = __webpack_require__(0);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.APP_KEY] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].APP_KEY;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.CHANNEL] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].getChannel();

  next(function (response) {
    return response;
  });
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = el.dataset.title;
  },
  update: function update(el, binding) {
    document.title = el.dataset.title;
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__privacy_terms_en_vue___default.a);
  }
}).$mount('#privacy_terms_en');

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__privacy_en_privacy_en_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__privacy_en_privacy_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__privacy_en_privacy_en_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__terms_en_terms_en_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__terms_en_terms_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__terms_en_terms_en_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacy',
  data: function data() {
    return {};
  },

  components: {
    privacyEn: __WEBPACK_IMPORTED_MODULE_0__privacy_en_privacy_en_vue___default.a,
    termsEn: __WEBPACK_IMPORTED_MODULE_1__terms_en_terms_en_vue___default.a
  }
});

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacy {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacy h1 {\n  margin-top: 0.5rem;\n  font-weight: bold;\n  font-size: 0.26rem;\n}\n#privacy div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacy div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacy div a {\n  color: #000;\n}\n#privacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

var docEl = document.documentElement;
var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
var remSize = 100;
var recalc = function recalc() {
  var clientWidth = docEl.clientWidth;
  if (!clientWidth) {
    return;
  }
  if (clientWidth <= 720) {
    docEl.style.fontSize = remSize * (clientWidth / 500) + 'px';
  } else {
    docEl.style.fontSize = remSize + 'px';
  }
};

if (document.addEventListener) {
  window.addEventListener(resizeEvt, recalc, false);
  document.addEventListener('DOMContentLoaded', recalc, false);
}

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    staticClass: "body-content"
  }, [_c('termsEn'), _vm._v(" "), _c('privacyEn')], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fe178eba", module.exports)
  }
}

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(382);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("212743dd", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-fe178eba\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_terms_en.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-fe178eba\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_terms_en.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/privacy_en/privacy_en.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] privacy_en.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37ecc2e3", Component.options)
  } else {
    hotAPI.reload("data-v-37ecc2e3", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(107)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/terms_en/terms_en.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] terms_en.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-695f05c3", Component.options)
  } else {
    hotAPI.reload("data-v-695f05c3", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  test: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  test_na: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  prod: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  },
  prod_na: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  }
};

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacyEn',
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  }
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'termsEn',
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  }
});

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacyEn {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacyEn h1 {\n  font-weight: bold;\n  font-size: 0.2rem;\n}\n#privacyEn div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacyEn div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacyEn div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacyEn div a {\n  color: #000;\n}\n#privacyEn div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacyEn {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacyEn h1 {\n  font-weight: bold;\n  font-size: 0.2rem;\n}\n#privacyEn div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacyEn div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacyEn div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacyEn div a {\n  color: #000;\n}\n#privacyEn div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacyEn"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('h1', [_vm._v("Privacy Policy")]), _vm._v(" "), _c('div', [_vm._v("Last updated: Jun 29, 2021")]), _vm._v(" "), _c('div', [_vm._v("CZUR Tech and its affiliates (hereinafter collectively referred to as “CZUR Tech”) respect and protect the privacy of all users who use CZUR Tech services. To provide users with more accurate and personalized services, CZUR Tech may use and disclose users’ personal information in accordance with this Privacy Policy. CZUR Tech will treat users’ information with high diligence and prudence. Except as otherwise provided in this Privacy Policy, CZUR Tech will not disclose or provide users’ information to any third party without users’ prior consent. CZUR Tech will update this Privacy Policy from time to time.")]), _vm._v(" "), _c('div', [_vm._v("By agreeing to CZUR Tech Services Agreement, you are deemed to have agreed to the entire contents of this Privacy Policy. This Privacy Policy is an integral part of CZUR Tech Services Agreement.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("1. Application Scope")]), _vm._v(" "), _c('div', [_vm._v("a) Personal registration information provided by you when you register for a CZUR account;")]), _vm._v(" "), _c('div', [_vm._v("b) Information on your browser and computer that are automatically received and recorded by CZUR Tech when you use CZUR Tech network services or access to the websites of CZUR Tech, including but not limited to your IP address, browser type, language used, date and time of access, hardware and software features, and web page records you need, etc.")]), _vm._v(" "), _c('div', [_vm._v("c) Users’ personal data obtained by the company from a business partner through legal channels.")]), _vm._v(" "), _c('div', [_vm._v("You understand and agree that the following information does not apply to this Privacy Policy:")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("● The keyword information that you enter when using the search service provided by CZUR Tech;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("● Information and data that you publish on CZUR Tech platform and collected by CZUR Tech, including but not limited to information concerning participating activities, transaction and rating details;")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("● Your violation of laws or rules of CZUR Tech and the measures that CZUR Tech has taken against you.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("2. Information Use")]), _vm._v(" "), _c('div', [_vm._v("a) CZUR Tech will not provide, sell, rent, share or trade your personal information to any unrelated third party, unless we have your consent in advance, or the third party and CZUR Tech (including CZUR Tech’s affiliates) respectively or jointly provide services to you, and after the service, the third party will be banned from accessing all such information that it has previously been able to access.")]), _vm._v(" "), _c('div', [_vm._v("b) CZUR Tech does not allow any third party to collect, edit, sell or distribute your personal information by any means. CZUR Tech has the right to immediately terminate the services agreement with the user if he or she involves in the above activities.")]), _vm._v(" "), _c('div', [_vm._v("c) To offer you services, CZUR Tech may use your information to offer you with contents that you are interested in, including but not limited to sending you product and service information, or sharing information with CZUR Tech’s partners, so that they can send you information about their products and services (the latter requires your prior consent).")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("3. Information Disclosure")]), _vm._v(" "), _c('div', [_vm._v("Under the following circumstances, CZUR Tech will disclose your personal information wholly or partially according to your personal willingness or the law:")]), _vm._v(" "), _c('div', [_vm._v("a) Discloses your information to third parties with your prior consent;")]), _vm._v(" "), _c('div', [_vm._v("b) Shares your information with third parties so as to provide the products and services you request;")]), _vm._v(" "), _c('div', [_vm._v("c) Discloses your information to third parties or administrative or judicial authorities in accordance with relevant law and provisions, or at the request of administrative or judicial authorities;")]), _vm._v(" "), _c('div', [_vm._v("d) Discloses your information to a third party when you have violated relevant China’s laws, regulations or the CZUR Tech Services Agreement or related rules;")]), _vm._v(" "), _c('div', [_vm._v("e) In the case that you are a qualified intellectual property complainant and have filed a complaint, and your information should be disclosed to the respondent at the request of the respondent so that both parties can handle possible rights disputes;")]), _vm._v(" "), _c('div', [_vm._v("f) In a transaction created on the CZUR Tech platform, if any transaction party performs or partially performs the transaction obligation and makes request for information disclosure, CZUR Tech has the right to provide the user with the necessary info, such as contact information to the counter party to facilitate the transaction or solve disputes.")]), _vm._v(" "), _c('div', [_vm._v("g) Other disclosures that CZUR Tech believes to be appropriate in accordance with laws, regulations or website policies.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("4. Disclosures without User Consent")]), _vm._v(" "), _c('div', [_vm._v("According to relevant laws and regulations, collecting your information in the following cases does not require your consent:")]), _vm._v(" "), _c('div', [_vm._v("a) Cases related to national security and national defense security;")]), _vm._v(" "), _c('div', [_vm._v("b) Cases related to public safety, public health, and major public interests;")]), _vm._v(" "), _c('div', [_vm._v("c) Cases related to criminal investigation, prosecution, trial, and judgments execution;")]), _vm._v(" "), _c('div', [_vm._v("d) Cases related to important legal rights, such as life or property interests of the information subject or other individuals, but is difficult to get your own consent;")]), _vm._v(" "), _c('div', [_vm._v("e) The information collected is disclosed to the public by yourself;")]), _vm._v(" "), _c('div', [_vm._v("f) Information collected from legal publishing channels, such as legitimate news reports, government information disclosure channels, etc.;")]), _vm._v(" "), _c('div', [_vm._v("g) Necessary information for signing a contract according to your requirements;")]), _vm._v(" "), _c('div', [_vm._v("h) Necessary information for safe and stable operation of CZUR Tech services, such as for the discovery or disposal of products or services;")]), _vm._v(" "), _c('div', [_vm._v("i) Necessary information for legal news reporting;")]), _vm._v(" "), _c('div', [_vm._v("j) Necessary information for academic research institutions that conduct statistical or academic research based on public interest and provide academic research or description results where information contained in the results is de-identified;")]), _vm._v(" "), _c('div', [_vm._v("k) Other circumstances as stipulated by laws and regulations.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("5. Information Storage and Exchange")]), _vm._v(" "), _c('div', [_vm._v("The information and data collected by CZUR Tech will be stored on the servers of CZUR Tech and/or its affiliates, which may be transmitted to your country or region or be accessed, stored or displayed outside the country or region where the information and data are collected.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("6. Cookies Use")]), _vm._v(" "), _c('div', [_vm._v("a) In the event that you accept cookies, CZUR Tech will set or access cookies on your computer so that you can log in to or use cookies-based CZUR platform services or features. CZUR Tech uses cookies to provide you with more thoughtful and personalized services, including promotional services.")]), _vm._v(" "), _c('div', [_vm._v("b) You have the right to accept or decline cookies. You can refuse cookies by changing your browser settings. However, if you choose to decline cookies, you may not be able to log in to or use cookies-based CZUR platform services or features.")]), _vm._v(" "), _c('div', [_vm._v("c) This policy will apply to information obtained through cookies set by CZUR Tech.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("7. Information Security")]), _vm._v(" "), _c('div', [_vm._v("a)  CZUR accounts have security protection function. Please carefully keep your username and password. CZUR Tech will ensure that your information will not be lost, abused or altered with security measures such as encrypting user passwords. Despite the aforementioned security measures, please note that there are no “perfect security measures” on information network.")]), _vm._v(" "), _c('div', [_vm._v("b) When making online transactions with CZUR Tech network services, you will inevitably disclose your personal information, such as contact information or postal address to the counter party or potential counter party. Please take care of your personal information and provide them to others only when necessary. If you find that your personal information is leaked, especially if the username and password are leaked, please contact CZUR’s customer service immediately.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("8. Description of software privacy rights")]), _vm._v(" "), _c('div', [_vm._v("a) Display the pop-up box and full screen interface to other applications.")]), _vm._v(" "), _c('div', [_vm._v("b) Allows the app to modify or delete photos, media content, and files on the memory card.")]), _vm._v(" "), _c('div', [_vm._v("c) The app are allowed to obtain location information based on GPS, base station, Wi Fi and other network sources. This may increase power consumption.")]), _vm._v(" "), _c('div', [_vm._v("d) Allows the app to retrieve user location information when running in the background.")]), _vm._v(" "), _c('div', [_vm._v("e) Allow the app to record audio.")]), _vm._v(" "), _c('div', [_vm._v("f) Allow the app to take photos and videos.")]), _vm._v(" "), _c('div', [_vm._v("g) Allows the app to read photos, media content, and files on the memory card.")]), _vm._v(" "), _c('div', [_vm._v("h) Allow the app to get the phone number, call status and dialed number.")]), _vm._v(" "), _c('div', [_vm._v("i) Modify the settings in the settings application.")]), _vm._v(" "), _c('div', [_vm._v("j) Allow the app to open Bluetooth permissions and connect BLE Bluetooth devices.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("9.Information collected by third-party services and security guarantee functions:")]), _vm._v(" "), _c('div', [_vm._v("a) com.tencent.bugly (Bugly; Tencent Bugly); Information Collected: Requires network and storage permissions, collects basic device information such as brand, model; Purpose: Provide exception log analysis services; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("b) com.huawei.hms (Huawei; Huawei Push); Information Collected: Unique device identifier, Token, network information; Purpose: Information push; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("c) com.sina.weibo (Weibo; Sina Weibo); Information Collected: Device information; Purpose: For sharing, third-party login; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_vm._v("e) com.huawei.agconnect (Huawei; Huawei Joint Operation Application); Information Collected: Device information; Purpose: Huawei App Market distribution service; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("f) cn.jpush.android (Aurora; Aurora Push); Information Collected: Device information, geographical location, network information; Purpose: Information push; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_vm._v("h) com.eg.android.AlipayGphone (Alipay); Information Collected: Device information (such as IMEI, IMSI, SIM card serial number, MAC address, AndroidID, SSID, BSSID, basic device information [model\\manufacturer etc.]), network information; Purpose: Purchase VIP services etc.; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("i) com.xiaomi.mipush (Xiaomi; Xiaomi Push); Information Collected: Unique device identifier, Token, network information; Purpose: Information push; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("j) com.heytap.mcs (OPPO; OPPO push); Information Collected: Unique device identifier, Token, network information; Purpose: Information push; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("k) com.vivo.push (VIVO; VIVO push); Information Collected: Unique device identifier, Token, network information; Purpose: Information push; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _c('div', [_vm._v("l) io.agora (Sound Network); Information Collected: Device type, device model, CPU information, battery power information, operating system information, sender and receiver user ID, user attributes, channel information, usage duration, channel setting name, log; Purpose: Provide video and audio conference function; Collection Method: Local collection on mobile phone through SDK.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_vm._v("This is some content in the privacy policy of the application, please help me translate it into English.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("10. Special provisions applicable to certain country/region")]), _vm._v(" "), _c('div', [_vm._v("Regarding the personal information collected and generated in China (for the purpose of this clause, excluding HK, Macao and Taiwan), we will comply with the PRC Cybersecurity Law on cross-border transfer of personal information and important business data by operator of key information infrastructure.")]), _vm._v(" "), _c('div', [_vm._v("In Hong Kong Special Administrative Region, Macao Special Administrative Region and Taiwan, Our Products and services will comply with all applicable legal provisions of each of the regions including but not limited to the HK Personal Data (Privacy) Ordinance.")]), _vm._v(" "), _c('div', [_vm._v("In the circumstance where the EU General Data Protection Regulation applies to the services provided by us, we commit that you will in addition have the relevant rights and interests under the Regulation including but not limited to right of access to data (you have the right to obtain from us confirmation as to whether or not personal data concerning you are being processed, where they are being processed and for what purpose they are being processed), right to data portability (under certain condition, we will provide to you or another designated data controller upon your request your data in the form stipulated by the Regulation), right to erase (under certain condition, we will erase all personal data concerning you without undue delay upon your request).")]), _vm._v(" "), _c('div', [_vm._v("In the United States, Our Products and services will comply with all applicable legal provisions including but not limited to the US Privacy Act, the US Electronic Communications Privacy Act and the US Children's Online Privacy Protection Act.")]), _vm._v(" "), _c('div', [_vm._v("If your rights and interests under the applicable legal provisions differ from what is stipulated herein, that part of the applicable legal provisions prevails, provided, however, in case the abovementioned legal provision conflicts with the mandatory provision under the governing law of the Privacy Policy, we will on the premise of abiding by the mandatory provision, comply with the applicable legal provision to the extent possible.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("11. Notification and Revision")]), _vm._v(" "), _c('div', [_vm._v("We may revise the terms of this Privacy Policy as appropriate and such modifications form part of this Privacy Policy. For major changes, we will provide clear notices, and you may opt out of CZUR Tech services; in such case, if you continue to use CZUR Tech services, it indicates that you agree to the revised Privacy Policy.")]), _vm._v(" "), _c('div', [_vm._v("We always put your satisfaction in the first place and we encourage you to review our Privacy Policy each time you use CZUR Tech services.")]), _vm._v(" "), _c('div', [_vm._v("We may issue service-related announcements when necessary (for example, when we suspend a service due to system maintenance). You may not be able to cancel these announcements that are related to the services and that are not promotion.")]), _vm._v(" "), _c('div', [_vm._v("You are obligated to keep your account and password confidential.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("12. Contact Us")]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("d) com.umeng (Umeng); Information Collected: Device information (IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM card IMSI/ICCID), location information, network information; Purpose: For third-party (WeChat, QQ) shared login, sharing; Collection Method: Local collection on mobile phone through SDK. Detailed privacy policy link:\n     "), _c('a', {
    attrs: {
      "href": "https://www.umeng.com/page/policy"
    }
  }, [_vm._v("https://www.umeng.com/page/policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("g) "), _c('a', {
    attrs: {
      "href": "com.tencent.mm"
    }
  }, [_vm._v("com.tencent.mm")]), _vm._v(" (WeChat); Information Collected: MAC address, unique device identifier; Purpose: Purchase VIP services etc.; Collection Method: Local collection on mobile phone through SDK.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("For more detailed information, you can visit: "), _c('a', {
    attrs: {
      "href": "https://passport.czur.cc/3dsharelist.html"
    }
  }, [_vm._v("https://passport.czur.cc/3dsharelist.html")]), _vm._v(" Device Information")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("If you have any complaints or reports about the network information security, or if you have any questions, comments or suggestions about this Privacy Policy, your information, or any questions regarding this statement or the privacy policy of CZUR Tech, please contact us at: \n     "), _c('a', {
    attrs: {
      "href": "mailto:service@czur.com"
    }
  }, [_vm._v("service@czur.com")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37ecc2e3", module.exports)
  }
}

/***/ })

},[266]);


// WEBPACK FOOTER //
// static/js/module/privacy_terms_en.daaf76adc7dcf20a715f.js